import { VideoControllerProps } from '../../view/common';

export const Videos = {
    INVITE_WELCOME: {
        id: 'invite_welcome',
        url: `https://www.loom.com/embed/ac371d62228f46d48e4f5b8bbf2b1acb?sid=c8527e20-c6f9-4bb9-9f4f-d4f65c957956`,
        title: 'Welcome',
    },
} satisfies Record<string, VideoControllerProps>;
